import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable, Inject } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { PerfilService } from "src/app/services/ajs-perfil.service";

export interface TotalsResponse {
  acoesPendentes: AcoesPendentes;
}

export interface AcoesPendentes {
  enviadas: number;
  emProcessamento: number;
}

export interface TotalAtrasadasResponse {
  encomendasAtrasadas: number;
}

export interface TotalNaoEncontradasResponse {
  naoEncontradas: number;
}

@Injectable()
export class OccurrenceApiService {
  private URL: string = environment.angularJSconstants.URLAPIDIVERGENCIA;

  constructor(
    @Inject(PerfilService) public profile: PerfilService,
    private http: HttpClient
  ) {}

  async getDelayedCount(): Promise<TotalAtrasadasResponse> {
    const token = localStorage.getItem("ls.token").replace(/"/g, "");

    if (token) {
      const headers = new HttpHeaders({
        Authorization: token
      });

      return await this.http
        .get<TotalAtrasadasResponse>(`${this.URL}/atrasadas/contador`, {
          headers
        })
        .toPromise();
    }
  }

  async getTotals(): Promise<TotalsResponse> {
    const token = localStorage.getItem("ls.token").replace(/"/g, "");

    if (token) {
      const headers = new HttpHeaders({
        Authorization: token
      });

      return await this.http
        .get<TotalsResponse>(`${this.URL}/v2/contadores`, { headers })
        .toPromise();
    }
  }

  async getNaoEncontradas(): Promise<TotalNaoEncontradasResponse> {
    const token = localStorage.getItem("ls.token").replace(/"/g, "");

    if (token) {
      const headers = new HttpHeaders({
        Authorization: token
      });

      const data = localStorage.getItem("ls.user")
        ? JSON.parse(localStorage.getItem("ls.user")).id
        : 0;
      return await this.http
        .get<TotalNaoEncontradasResponse>(
          `${this.URL}/nao-encontradas/contadores?clienteId=${data}`,
          { headers }
        )
        .toPromise();
    }
  }
}
